module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/top-done-76e4606396f8c5513087782752dacdc9.svg";